<template>
  <div>
    <div style="margin: 0px 0px 0px 0px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <div
          style="background: #c5d0e2; height: 1px; margin: 4px 0px 20px 0px"
        ></div>
        <el-tab-pane :label="$t('organstructure.headoffice')" name="first">
        </el-tab-pane>
        <el-tab-pane :label="$t('organstructure.branch')" name="second">
        </el-tab-pane>
        <el-tab-pane :label="$t('organstructure.fleetmanage')" name="third">
        </el-tab-pane>
        <el-tab-pane :label="$t('organstructure.routemanage')" name="fourth">
        </el-tab-pane>
      </el-tabs>
      <div v-show="activeName == 'first'">
        <head_office v-on:newheadofficeInfo="newheadofficeInfo"> </head_office>
      </div>
      <div v-show="activeName == 'second'">
        <branch_office></branch_office>
      </div>
      <div v-show="activeName == 'third'">
        <fleet_Management></fleet_Management>
      </div>
      <div v-show="activeName == 'fourth'">
        <line_Management></line_Management>
      </div>
    </div>
  </div>
</template>

<script>
import head_office from "./components/headoffice.vue";
import branch_office from "./components/branchoffice.vue";
import fleet_Management from "./components/fleetManagement.vue";
import line_Management from "./components/lineManagement.vue";
export default {
  name: "organstructure",
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    head_office,
    branch_office,
    fleet_Management,
    line_Management,
  },
  methods: {
    handleClick(tab, event) {},
    newheadofficeInfo(headofficeInfo) {},
  },
};
</script>

<style>


</style>
